import { defineNuxtRouteMiddleware, useNuxtApp } from '#app'
import { useCookie, useGuard } from '#imports'

export default defineNuxtRouteMiddleware(async (to) => {
    const guard = useGuard()
    const sessionExpiry = useCookie('session_expiry', { readonly: true })
    const nuxtApp = useNuxtApp()

    // useGuard() returns a thenable from useUserInfo().enrich(); awaiting it
    // waits for the underlying user-info query so can() reads resolved data
    // instead of the query's initial empty state on SSR.
    if (import.meta.server) {
        await guard
    }

    const isHydratingServerRenderedPage = import.meta.client && nuxtApp.isHydrating && nuxtApp.payload.serverRendered

    // On client navigation, the user-info query is cached (TTL 10s), so a
    // status flip between navigations is invisible until the cache expires.
    // Force a refresh so can() evaluates against the same fresh data SSR sees.
    // Skip during SSR hydration — the server payload is already fresh.
    if (import.meta.client && sessionExpiry.value && !isHydratingServerRenderedPage) {
        await guard.refresh({ cause: 'refresh:manual', dedupe: 'defer' })
    }

    return await guard.can(to)
})
